module.exports = __webpack_public_path__ + "static/media/daily-life-2023-3.98452848.webp";